// extracted by mini-css-extract-plugin
export default {"details":"styles_details__xn6Tg","detailsCollapse":"styles_detailsCollapse__Gg46F","detailsTitle":"styles_detailsTitle__WXrmX","icon":"styles_icon__mcYjq"};